var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-description"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"description"},[_vm._v("\n\t\t"+_vm._s(_vm.description)+"\n\t\t"),_c('span',{staticClass:"link-description",on:{"click":function($event){return _vm.$emit('handle-click')}}},[_vm._v(_vm._s(_vm.linkDescription))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }